/** @file The Timeline panel's tabs; the curve editor (E4) appends its entry to this list. */
import type { CatalogKey } from '@pose2d/i18n/types';
import type { FunctionComponent } from 'react';
import type { EditorDeps } from '../../playback/editorDeps';
import { CurvesTab } from '../curves/CurvesTab';
import { DopesheetView } from './DopesheetView';

/** One tab: id, translated title key and the view rendered for the playhead's animation. */
export interface TimelineView {
  id: string;
  title: CatalogKey;
  View: FunctionComponent<{ deps: EditorDeps }>;
}

/** Dopesheet first (the default tab), then the curve editor. */
export const TIMELINE_VIEWS: readonly TimelineView[] = [
  { id: 'dopesheet', title: 'panels.timeline.dopesheet', View: DopesheetView },
  { id: 'curves', title: 'curves.tab', View: CurvesTab },
];
